import { Component, Vue } from 'vue-property-decorator';
import { getStyleSkinName } from '@/tools/helpers.ts';
import SideNavigation from '@/components/SideNavigation/SideNavigation';
import { request } from '@/tools/request.ts';

@Component<RegistrationStatus>({
  components: {
    SideNavigation,
  },
})
export default class RegistrationStatus extends Vue {
  protected getStyle: any = getStyleSkinName();
  protected schoolClasses: any = [];
  protected classOne: any = [];
  protected classTwo: any = [];
  protected classThree: any = [];
  protected classLoading: boolean = true;

  public mounted() {
    this.getClasses();    
  }

  protected getClasses() {
    request('get', 'https://us-central1-lexlibris-api.cloudfunctions.net/webApi/classes').then(
      (response: any) => {
        
        // console.log(JSON.stringify(response.data,null,2))
        // {
        //   "id": "2019001",
        //   "data": {
        //     "status": "not enrolled", // enrolled / pending / not enrolled
        //     "name": "Ashley Berendse",
        //     "class": "1 C"
        //   }
        // },

        this.classLoading = false;
        let classLoopIndex: number = 0;
        response.data.forEach((element: any, index: any) => {
          if (element.data.class === '1 A') this.classOne.push(element);
          if (element.data.class === '1 B') this.classTwo.push(element);
          if (element.data.class === '1 C') this.classThree.push(element);
          classLoopIndex = index + 1;
          if (classLoopIndex === response.data.length) {
            this.fillClassesArray();
          }
        });
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected fillClassesArray() {
    this.schoolClasses = [{
      class: '1ºA',
      registered: this.countEnrolledStudents(this.classOne),
      students: this.classOne,
    }, {
      class: '1ºB',
      registered: this.countEnrolledStudents(this.classTwo),
      students: this.classTwo,
    }, {
      class: '1ºC',
      registered: this.countEnrolledStudents(this.classThree),
      students: this.classThree,
    }]
  }

  protected countEnrolledStudents(studentArray: any) {
    let count: number = 0;
    studentArray.forEach((student: any) => {
      if (student.data.status === 'enrolled') count = count + 1;
    });
    return count;
  }

}
